import axios from 'axios';

const hasUrlParam = () => {
    try {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.has('dyApiPreview') ? [urlParams.get('dyApiPreview')] : '';
    } catch (e) {
        return '';
    }
};

export const transformProductFromSlot = (slot, decisionID) => {
    const { productData: item, sku, slotId } = slot;
    return {
        ...item,
        sku,
        slotId,
        catentryId: item.catid,
        images: [{ image: item.image_url }],
        productUrl: item.url,
        ctaViewDetailsLink: item.url,
        dyItemTracking: { 'data-dy-slot-id': slotId, 'data-dy-decision-id': decisionID },
    };
};

export const DynamicYield = function (config) {
    const {
        uri = 'https://direct.dy-api.com',
        engagementUri = 'https://direct-collect.dy-api.com',
        clientGuid,
    } = config || {};
    const http = axios.create({
        baseURL: uri,
        timeout: 3000,
        headers: {
            'DY-API-Key': clientGuid,
        },
    });

    const engagementHttp = axios.create({
        baseURL: engagementUri,
        timeout: 3000,
        headers: {
            'DY-API-Key': clientGuid,
        },
    });

    this.choose = (names, data = [], context = {}, options = {}) => {
        const dyid = window.DY.dyid;
        const dyJsession = window.DY.jsession;
        const consentStatus = ['local', 'development'].includes(process.env.NODE_ENV)
            ? true
            : !window.DYO.ActiveConsent.isUserOptOut();
        const { type } = options;
        const globalContenxt = DY.recommendationContext || {};
        const page = { data, ...(type ? { type } : globalContenxt) };
        page.location = window.location.href;
        if (!names || !names.length) {
            return Promise.reject('No names provided');
        }
        return http
            .post('/v2/serve/user/choose', {
                selector: {
                    names,
                    preview: {
                        ids: hasUrlParam(),
                    },
                },
                user: {
                    dyid: dyid || '',
                    dyid_server: dyid || '',
                    active_consent_accepted: consentStatus || false,
                },
                session: {
                    dy: dyJsession || '',
                },
                context: {
                    page,
                    ...(context || {}),
                },
                options: {
                    isImplicitPageview: false,
                    returnAnalyticsMetadata: true,
                    isImplicitImpressionMode: true,
                    isImplicitClientData: false,
                    ...(options || {}),
                },
            })
            .then(({ data }) => {
                return names.reduce((acc, name) => {
                    const choice = data.choices.find(choice => choice.name === name);
                    const { variations, decisionId: decisionID } = choice || {};
                    const [variation] = variations || [];
                    const { payload, analyticsMetadata } = variation || {};
                    const { data: variationData } = payload || {};
                    const { custom, slots } = variationData || {};
                    const { trackingExp, trackingVar, ...restCustom } = custom || {};
                    if (slots && slots.length) {
                        acc[name] = {
                            decisionID,
                            analyticsMetadata,
                            ...(restCustom || {}),
                            productRecs: slots.map(slot => transformProductFromSlot(slot, decisionID)),
                            dyContainerTracking: {
                                'data-dy-tracking-exp': trackingExp,
                                'data-dy-tracking-var': trackingVar,
                                'data-dy-decision-id': decisionID,
                            },
                        };
                    } else {
                        acc[name] = {
                            productRecs: [],
                        };
                    }
                    return acc;
                }, {});
            });
    };

    this.engagment = (engagementType, options = {}) => {
        const dyid = window.DY.dyid;
        const dyJsession = window.DY.jsession;
        const consentStatus = ['local', 'development'].includes(process.env.NODE_ENV)
            ? true
            : !window.DYO.ActiveConsent.isUserOptOut();
        const page = { data: [], ...(DY.recommendationContext || {}) };
        page.location = window.location.href;
        return engagementHttp.post('/v2/collect/user/engagement', {
            engagements: engagementType,
            user: {
                dyid: dyid || '',
                dyid_server: dyid || '',
                active_consent_accepted: consentStatus || false,
            },
            session: {
                dy: dyJsession || '',
            },
        });
    };
};
